// © Microsoft Corporation. All rights reserved.
const sourcePath = "https://assets.msn.com/staticsb/statics/latest/community/";

export const activityImages = {
    trophy: sourcePath+"img/profile/activity/cup.svg",
    commenter: sourcePath+"img/profile/activity/commenter.png"
};
export const profileImages = {
    privateProfile: sourcePath+"img/profile/private-profile.svg",
    zeroComments: sourcePath+"img/profile/zero_comments.svg",
    zeroUsers: sourcePath+"img/profile/zero_users.svg",
    zeroActivity: sourcePath+"img/profile/zero_activity.svg"
};
export const logoImages = {
    facebook: sourcePath+"img/logo/facebook.svg",
    google: sourcePath+"img/logo/google.svg",
    microsoft: sourcePath+"img/logo/microsoft.svg",
    microsoftText: sourcePath+"img/logo/microsoft_text.png",
    msNews: sourcePath+"img/logo/msnews_logo.svg"
};
export const placeholderImages = {
    avatar: sourcePath+"img/avatar-placeholder.svg",
    peopleAvatar: sourcePath+"img/people-avatar.svg",
    notSocialAvatar: sourcePath+"img/profile/not_social_avatar_placeholder.svg",
    content: "http://img-s-msn-com.akamaized.net/tenant/amp/entityid/AAdQPFo.img"
};
export const guidlineImages = {
    g1: sourcePath+"img/guidelines/g1_2.png",
    g2: sourcePath+"img/guidelines/g2_2.png",
    g3: sourcePath+"img/guidelines/g3_2.png",
    g4: sourcePath+"img/guidelines/g4_2.png",
    g5: sourcePath+"img/guidelines/g5_2.png"
};
export const onboardingImages = {
    underageBg: sourcePath+"img/onboard/underage_bg.png",
    welcomeBg: sourcePath+"img/onboard/welcoming_bg.png"
};